import { FlexItem } from '@bigcommerce/big-design';

export function FilterFlexItem({ className, children }) {
	return (
		<FlexItem
			className={className}
			alignSelf="center"
			flexBasis="auto"
			flexGrow={0}
			flexOrder={0}
			flexShrink={1}
			marginHorizontal="small"
		>
			{children}
		</FlexItem>
	);
}
